document.addEventListener('DOMContentLoaded', function() {
    const orderCycleSelect = document.getElementById('orderCycle');
    const orderCycleDivs = document.querySelectorAll('.order_cycle');

    // Verstecke initial alle Bestellzyklen außer dem ersten
    orderCycleDivs.forEach((div, index) => {
        if (index !== 0) {
            div.style.display = 'none';
        }
    });

    // Event-Listener für Dropdown
    if (orderCycleSelect) {
        orderCycleSelect.addEventListener('change', function() {
            const selectedCycleId = this.value;
            
            // Verstecke alle Bestellzyklen
            orderCycleDivs.forEach(div => {
                div.style.display = 'none';
            });

            // Zeige den ausgewählten Bestellzyklus
            const selectedCycleDiv = document.querySelector(`.order_cycle[data-cycle="${selectedCycleId}"]`);
            if (selectedCycleDiv) {
                selectedCycleDiv.style.display = 'block';
            }
        });
    }
});